'use client'
import { PreviewPageIcon } from '@/components/v1/page-style/admin/editor-console/content/content.style'
import { Modal } from '@/components/v2/organisms/modal/modal'
import { NavigationIndex } from '@/components/v2/organisms/navigation/navigation-index/navigation-index'
import { Footer } from '@/components/v3/organisms/navigation/footer/footer'
import { NavigationClientWrapper } from '@/components/v3/organisms/navigation/navigation-client-wrapper/navigation-client-wrapper'
import { API_URL, getApiV1BaseUrl } from '@/constants'
import { AppContext } from '@/context/applicationContext'
import { useUser } from '@/hooks/use-user'
import { UserRole } from '@/store/models/user'
import { logOut } from '@/utils/auth/log-out'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { toast } from 'sonner'
import { PreviewMode } from '../article/article.style'
import { Label } from '../ui/input/input.label.style'
import extended from './extended.class'
import { MainContent } from './main.style'

export type Crediential = {
  email: string
  password: string
}

export type SignupDataType = {
  email: string
  password: string
  firstName: string
  lastName: string
  role: UserRole
  weddingDate?: string
}

const MainLayout = (props: any) => {
  const children = props.children
  const navigationData = props.pageProps.navigationData
  const [features, setFeature] = useState({})
  const { user, refreshUser } = useUser()
  const router = useRouter()

  const {
    query: { edit },
  } = router

  const callApi = ({ param }: any) => {
    return param
  }

  const getCurrentUser = async () => {
    try {
      const freshUser = await refreshUser()
      return freshUser || {}
    } catch (error: any) {
      toast.error(error?.toast || error)
    }
  }

  //! For supplier automatic create account without email confirmation
  const onAutoCreateSupplierAccount = async (value: SignupDataType) => {
    const formData = new FormData()
    Object.entries(value).forEach(([key, value]) => {
      formData.append(key, value)
    })
    try {
      const res = await fetch(`${getApiV1BaseUrl()}${API_URL.AUTH.REGISTER}`, {
        method: 'POST',
        body: formData,
      })

      if (!res.ok) {
        console.log('error registering user', await res.json())
        return
      }

      const user = await getCurrentUser()
      return user
    } catch (error: any) {
      toast.error(error?.toast)
    }
  }

  const onClickSignOut = logOut

  const value: any = {
    theme: 'base',
    callApi,
    features,
    setFeature,
    userdata: user,
    getCurrentUser,
    extended,
    updateUser: () => refreshUser(),
    onAutoCreateSupplierAccount,
    onClickSignOut,
  }

  const isArticleEditor = Boolean(parseInt(edit as string))

  return (
    <AppContext.Provider value={value}>
      {/* "navigationData" is available only for article pages, so it's prerendered on server */}
      {!navigationData && !isArticleEditor && <NavigationClientWrapper />}
      {navigationData && <NavigationIndex {...navigationData} />}
      <MainContent>{children}</MainContent>
      {router.query.previewBy && (
        <PreviewMode>
          <Label style={{ margin: 0 }}>Preview mode</Label>
          <PreviewPageIcon size={30} />
        </PreviewMode>
      )}
      {!isArticleEditor && <Footer />}
      <Modal />
    </AppContext.Provider>
  )
}

export default observer(MainLayout)
